import React, {useRef, useState} from "react";

export const CreditCardPreview = ({
  environment,
  allowFlip,
  brand,
  brandPosition,
  bankName,
  bankLogo,
  bankLogoPosition,
  cardNumber,
  cardHolder,
  expires,
  cvv,
  colorPrimary,
  colorSecondary,
  colorFont,
  cardImage,
  fontFamily,
  handleCopy,
  copied,
  colorBackground,
  lang,
}) => {
  const [flipped, setFlipped] = useState(false);
  const divRef = useRef(null);

  const handleFlip = () => {
    if (allowFlip === "N") return;
    setFlipped(!flipped);
  };


  return (
    <div
      className="bg-transparent"
      style={{
        width: environment === "PROD" ? "100vw" : 400,
        height: environment === "PROD" ? "100vh" : 250,
      }}
    >
      <div
        className="relative w-80 h-56 mb-10 w-full h-full"
        style={{ perspective: "1000px" }}
      >
        <div
          className={`relative w-full h-full transition-transform duration-700 ${
            flipped ? "rotate-y-180" : ""
          }`}
          style={{
            transformStyle: "preserve-3d",
            transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
          }}
          onClick={handleFlip}
        >
          <div
            ref={divRef}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backgroundImage:
                cardImage !== ""
                  ? `url(${cardImage})`
                  : colorSecondary !== ""
                  ? `linear-gradient(45deg, ${colorPrimary}, ${colorSecondary})`
                  : colorPrimary,
              backgroundSize: cardImage !== "" ? "cover" : "initial", // Para que la imagen de fondo cubra todo el div
              backgroundPosition: cardImage !== "" ? "center" : "initial", // Centrar la imagen
              borderRadius: "0.75rem", // rounded-xl
              boxShadow:
                "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)", // shadow-xl
              color: colorFont, // text-white
              padding: "0.75rem 1.25rem", // px-5 py-3
              backfaceVisibility: "hidden",
            }}
          >
            <h3 className="text-xl mb-4">{bankName.toUpperCase()}</h3>
            <div className="flex justify-between">
              <span
                className="text-xl font-bold tracking-widest"
                style={{ fontFamily: fontFamily }}
              >
                {cardNumber}
              </span>

              {brandPosition === "top-right" && (
                <div style={{ position: "absolute", top: 8, right: 8 }}>
                  {brand.toUpperCase() == "MASTER" && (
                    <img
                      className="w-10"
                      src="/logo_mastercard.png"
                      alt="Master"
                    />
                  )}
                  {brand.toUpperCase() == "VISA" && (
                    <img className="w-10" src="/logo_visa.png" alt="Visa" />
                  )}
                </div>
              )}

              {brandPosition === "top-left" && (
                <div style={{ position: "absolute", top: 8, left: 8 }}>
                  {brand.toUpperCase() == "MASTER" && (
                    <img
                      className="w-10"
                      src="/logo_mastercard.png"
                      alt="Master"
                    />
                  )}
                  {brand.toUpperCase() == "VISA" && (
                    <img className="w-10" src="/logo_visa.png" alt="Visa" />
                  )}
                </div>
              )}

              {brandPosition === "bottom-right" && (
                <div style={{ position: "absolute", bottom: 10, right: 10 }}>
                  {brand.toUpperCase() == "MASTER" && (
                    <img
                      className="w-12"
                      src="/logo_mastercard.png"
                      alt="Master"
                    />
                  )}
                  {brand.toUpperCase() == "VISA" && (
                    <img className="w-10" src="/logo_visa.png" alt="Visa" />
                  )}
                </div>
              )}

              {brandPosition === "bottom-left" && (
                <div style={{ position: "absolute", bottom: 10, left: 10 }}>
                  {brand.toUpperCase() == "MASTER" && (
                    <img
                      className="w-10"
                      src="/logo_mastercard.png"
                      alt="Master"
                    />
                  )}
                  {brand.toUpperCase() == "VISA" && (
                    <img className="w-10" src="/logo_visa.png" alt="Visa" />
                  )}
                </div>
              )}

              {bankLogo != "" && bankLogoPosition === "top-right" && (
                <div style={{ position: "absolute", top: 5, right: 5 }}>
                  <img
                      style={{ objectFit: "contain", width: 140, height: 60 }}
                    src={bankLogo}
                    alt="BankLogo"
                  />
                </div>
              )}

              {bankLogo != "" && bankLogoPosition === "top-left" && (
                <div style={{ position: "absolute", top: 5, left: 5 }}>
                  <img
                      style={{ objectFit: "contain", width: 140, height: 60 }}
                    className="w-40"
                    src={bankLogo}
                    alt="BankLogo"
                  />
                </div>
              )}

              {bankLogo != "" && bankLogoPosition === "bottom-left" && (
                <div style={{ position: "absolute", bottom: 5, left: 5 }}>
                  <img
                      style={{ objectFit: "contain", width: 140, height: 60 }}
                    className="w-40"
                    src={bankLogo}
                    alt="BankLogo"
                  />
                </div>
              )}

              {bankLogo != "" && bankLogoPosition === "bottom-right" && (
                <div style={{ position: "absolute", bottom: 5, right: 5 }}>
                  <img
                    style={{ objectFit: "contain", width: 140, height: 60 }}
                    className="w-40"
                    src={bankLogo}
                    alt="BankLogo"
                  />
                </div>
              )}
            </div>
            <div className="mt-4">
              {lang === "en" && <span>Card holder</span>}
              {lang === "es" && <span>Titular</span>}
              {lang === "pt" && <span>Titular do cartão</span>}
              <br />
              <span
                className="font-semibold text-lg"
                style={{ fontFamily: fontFamily }}
              >
                {" "}
                {cardHolder}{" "}
              </span>
            </div>
          </div>

          <div
              className="absolute w-full h-full bg-black rounded-xl shadow-xl text-gray-300 px-5 py-3"
              style={{
                backgroundColor: colorSecondary !== "" ? colorSecondary : '#000000',
                backfaceVisibility: "hidden",
                transform: "rotateY(180deg)",
              }}
          >
            <h3 className="text-xl mb-4">
              {lang === "en" && <span>Security Code</span>}
              {lang === "es" && <span>Código de Seguridad</span>}
              {lang === "pt" && <span>Código de segurança</span>}
              {lang === "de" && <span>Sicherheitscode</span>}
              {lang === "fr" && <span>Code de sécurité</span>}
              {lang === "it" && <span>Codice di sicurezza</span>}
            </h3>
            <div className="relative mt-2">
              <div className="bg-gray-700 h-10 w-full rounded-md"></div>
              <div className="mt-4 text-sm">
                <span className="block text-right">
                  {lang === "en" && (<span>For security purposes, do not share this code.</span>)}
                  {lang === "es" && (<span>Por motivos de seguridad, no comparta este código.</span>)}
                  {lang === "pt" && (<span>Por motivos de segurança, não compartilhe este código.</span>)}
                  {lang === "de" && (<span>Aus Sicherheitsgründen geben Sie diesen Code nicht weiter.</span>)}
                  {lang === "fr" && (<span>Pour des raisons de sécurité, ne partagez pas ce code.</span>)}
                  {lang === "it" && (<span>Per motivi di sicurezza, non condividere questo codice.</span>)}
                </span>
              </div>
              <span className="absolute top-2 right-4 text-white font-semibold">
                {cvv}
              </span>
            </div>
            <div className="mt-5">
              <span className="block" style={{fontFamily: fontFamily}}>
                {lang === "en" && <span>Expires</span>}
                {lang === "es" && <span>Expiración</span>}
                {lang === "pt" && <span>Expira</span>}
                {lang === "de" && <span>Ablaufdatum</span>}
                {lang === "fr" && <span>Date d'expiration</span>}
                {lang === "it" && <span>Scadenza</span>}
              </span>
              <span>{expires}</span>
            </div>
            <div className="absolute bottom-6 right-6">
              {brand.toUpperCase() == "MASTER" && (
                  <img className="w-12" src="/logo_mastercard.png" alt="Master"/>
              )}
              {brand.toUpperCase() == "VISA" && (
                  <img className="w-12" src="/logo_visa.png" alt="Visa"/>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
